export default __webpack_public_path__ + "static/media/anabelle.35daa15b.jpg";